import { createFileRoute, stripSearchParams, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { SellerOrdersPage } from '@/components/Business/SellerOrdersPage'
import {
  EMPTY_SELLER_ORDERS_SEARCH,
  type SellerOrdersSearch,
  sellerOrdersSearchSchema,
  withoutSellerOrdersDefaults,
} from '@/components/Business/sellerOrdersSearch'

/** Wiring only. The schema lives beside the page in `sellerOrdersSearch.ts`. */
export const Route = createFileRoute('/_app/business/seller-orders')({
  validateSearch: sellerOrdersSearchSchema,
  search: { middlewares: [stripSearchParams(EMPTY_SELLER_ORDERS_SEARCH)] },
  component: SellerOrdersRoute,
})

function SellerOrdersRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onSearchChange = useCallback(
    (next: Partial<SellerOrdersSearch>) =>
      void navigate({
        search: (current) => withoutSellerOrdersDefaults({ ...current, ...next }),
        replace: true,
        resetScroll: false,
      }),
    [navigate],
  )
  return <SellerOrdersPage search={search} onSearchChange={onSearchChange} />
}
